import { ExclamationCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

/**
 * Marks an archived project that was closed while still owed money: the name
 * turns red and a tooltip says how many invoices are unpaid.
 */
export function UnpaidInvoicesMarker({
  count,
  children
}: {
  count: number
  children: React.ReactNode
}) {
  const { t } = useTranslation()
  const label = t("projectUnpaid.marker", { count })

  return (
    <Tooltip title={label}>
      <span
        className="inline-flex max-w-full items-center gap-1.5 text-red-600"
        data-testid="unpaid-invoices-marker"
      >
        <ExclamationCircleFilled aria-hidden className="shrink-0" />
        <span className="sr-only">{label}</span>
        <span className="min-w-0 truncate">{children}</span>
      </span>
    </Tooltip>
  )
}
